import { downloadDocument, type DistributorDocument } from '@/services/application'

import { useFilePreview } from './previewModal'

export const useDocumentPreview = (getDocumentTitle: (document: DistributorDocument) => string) => {
  const { openingId, openFile } = useFilePreview()

  const openDocument = async (document: DistributorDocument) => {
    await openFile({
      id: document.id,
      title: getDocumentTitle(document),
      load: () => downloadDocument(document.id),
      fallbackContentType: document.fileType.mime,
      fallbackFileName: `${document.id}.${document.fileType.ext}`,
    })
  }

  return {
    openingDocumentId: openingId,
    openDocument,
  }
}
